import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class MembersStore {
  startDate: string = '';
  endDate: string = '';

  constructor() {
    makeObservable(this, {
      startDate: observable,
      endDate: observable,
      addStartDate: action,
      addEndDate: action,
      removeDates: action,
    });

    makePersistable(this, {
      name: 'MembersStore',
      properties: ['startDate', 'endDate'],
      storage: window.localStorage,
    });
  }
  addStartDate(startDate: string) {
    this.startDate = startDate;
  }
  addEndDate(endDate: string) {
    this.endDate = endDate;
  }
  removeDates() {
    this.startDate = '';
    this.endDate = '';
  }
}
export default MembersStore;
